import { useCallback } from "react";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../../api/adminApi";
import type { Category } from "../../../../../api/types/accessTypes";
import FundCommunicationMatrix from "./FundCommunicationMatrix";

interface Props {
  fundId: string;
  categories: Category[];
}

const FundCommunicationMatrixTab = ({ fundId, categories }: Props) => {
  const getFundPermissions = useCallback(async () => adminApi.getFundPermissions(fundId), [fundId]);

  const getContacts = useCallback(
    async () => adminApi.searchContacts({ fieldIds: [], includeFundInvestors: true, includeInboxData: false }),
    []
  );

  const [fundPermissions, permissionsFetchError] = useFetch(getFundPermissions);

  const [contactsResp, contactsFetchError] = useFetch(getContacts);

  const fetchError = permissionsFetchError || contactsFetchError;
  if (fetchError) {
    logError(fetchError, "[FundCommunicationMatrixTab]");
    return <DataLoadingFailed title="Loading fund communication matrix failed" />;
  }

  if (contactsResp === undefined || fundPermissions === undefined) {
    return <InlineLoader />;
  }

  return (
    <FundCommunicationMatrix
      categories={categories}
      permissionsResponse={fundPermissions}
      contacts={contactsResp.items}
    />
  );
};

export default FundCommunicationMatrixTab;
